import { createAction, props } from '@ngrx/store';
import { IProductSolutionRequest, IProductSolutionResponse } from '../models/product-solutions.model';

export const loadGetProductSolutions = createAction(
  '[GetProductSolutions] Load GetProductSolutionss',
  props<{ request: IProductSolutionRequest }>()
);

export const loadGetProductSolutionsSuccess = createAction(
  '[GetProductSolutions] Load GetProductSolutionss Success',
  props<{ response: IProductSolutionResponse }>()
);

export const loadGetProductSolutionsFailure = createAction(
  '[GetProductSolutions] Load GetProductSolutionss Failure',
  props<{ error: Error | any }>()
);
